export const GALLERY_FILE_NAME_MIN = 3;
export const GALLERY_FILE_NAME_MAX = 50;

export const GALLERY_MAX_UPLOAD_SIZE = 30 * 1024 * 1024;

export const GALLERY_MAX_UPLOAD_SIZE_MESSAGE =
  "The uploading file reaches the maximum limit";

export const getUploadBatchSizeError = (fileList = []) => {
  const totalSize = fileList.reduce((sum, file) => sum + (file?.size || 0), 0);
  return totalSize > GALLERY_MAX_UPLOAD_SIZE
    ? GALLERY_MAX_UPLOAD_SIZE_MESSAGE
    : null;
};

export const GALLERY_FILE_NAME_ALLOWED_PATTERN = /^[A-Za-z0-9.\-_(), ]+$/;

export const GALLERY_FILE_NAME_INVALID_CHARS_MESSAGE =
  "File name can only contain letters, numbers, spaces, and - _ . ( ) ,";

export const getGalleryFileNameEditError = (value) => {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return null;
  if (trimmed.length > GALLERY_FILE_NAME_MAX) {
    return "File name is too long";
  }
  if (!GALLERY_FILE_NAME_ALLOWED_PATTERN.test(trimmed)) {
    return GALLERY_FILE_NAME_INVALID_CHARS_MESSAGE;
  }
  return null;
};


export const getUploadFileNameError = (fileName) => {
  const trimmed = (fileName ?? "").trim();
  if (trimmed.length > GALLERY_FILE_NAME_MAX) {
    return `File name is too long. Rename it on your device and try again.`;
  }
  return null;
};
export const validateGalleryFileName = (value) => {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return "File name cannot be empty";
  if (trimmed.length < GALLERY_FILE_NAME_MIN) {
    return "File name should be at least 3 characters";
  }
  if (trimmed.length > GALLERY_FILE_NAME_MAX) {
    return "File name is too long";
  }
  if (!GALLERY_FILE_NAME_ALLOWED_PATTERN.test(trimmed)) {
    return GALLERY_FILE_NAME_INVALID_CHARS_MESSAGE;
  }
  return null;
};

export const getGalleryFileName = (item) =>
  item?.file_name || item?.path?.split("/").pop() || "";

export const sortGalleryFilesByName = (files) =>
  [...(files || [])].sort((a, b) =>
    getGalleryFileName(a).localeCompare(getGalleryFileName(b), undefined, {
      sensitivity: "base",
      numeric: true,
    })
  );

export const folderHasUploads = (data) => {
  if (!Array.isArray(data) || data.length === 0) return false;

  return data.some((item) => {
    const paths = item?.paths ?? item?.s3_paths ?? [];
    if (Array.isArray(paths)) {
      return paths.some(
        (p) => p && (typeof p === "string" ? p.length > 0 : Object.keys(p).length > 0)
      );
    }
    return !!paths;
  });
};

export const getDefaultUploadFileName = (file) => file?.name || "";

export const GALLERY_FOLDER_KEYS = {
  PATIENT_FILES: "patient_files",
  DISCHARGE_SUMMARY: "discharge_summary",
  CONSENT_FORM: "consent_form",
  RECYCLE_BIN: "recycle_bin",
};

export const GALLERY_PATIENT_APP_FOLDERS = [
  GALLERY_FOLDER_KEYS.PATIENT_FILES,
  GALLERY_FOLDER_KEYS.DISCHARGE_SUMMARY,
  GALLERY_FOLDER_KEYS.CONSENT_FORM,
];

export const isGalleryPatientAppFolder = (activeKey) =>
  GALLERY_PATIENT_APP_FOLDERS.includes(activeKey);

export const PATIENT_APP_UPLOAD_NOTE =
  "Files uploaded here will be visible to the patient in the Patient App.";
